import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;

  .main__wrapper {
    display: flex;
  }
`;
